import React from 'react';
import classNames from 'classnames';

import { Bubble } from '@lt/components';
import QuestionIcon from '@lt/components/icons-react/rebrand/QuestionOutline';

import styles from './LabelWithDescription.module.css';

interface LabelWithDescriptionProps {
  icon?: React.ReactNode;
  text?: string;
  tooltipTitle?: string;
  tooltipExtra?: string;
  flightNumber?: string;
  flightClassText?: string;
  isMobile: boolean;
}
/**
 * Компонент для отображения плашек в нижней части перелета
 */
export const LabelWithDescription = ({
  icon,
  text,
  tooltipTitle,
  tooltipExtra,
  flightNumber,
  flightClassText,
  isMobile,
}: LabelWithDescriptionProps): JSX.Element => (
  <Bubble
    title={
      tooltipTitle ? (
        <div className={styles.tooltipTitle}>{tooltipTitle}</div>
      ) : undefined
    }
    renderExtras={
      tooltipExtra
        ? () => <p className={styles.tooltipExtra}>{tooltipExtra}</p>
        : undefined
    }
    closeable={false}
  >
    <div className={styles.root}>
      <span>{icon}</span>
      {text && (
        <div
          className={classNames(styles.text, {
            [styles.textMobile]: isMobile,
          })}
        >
          <span>{text}</span>
          {flightNumber ? (
            <>
              {' '}
              <span>{flightNumber.split(' ').join('-')}</span>
              {flightClassText && (
                <>
                  {', '}
                  <span>{flightClassText}</span>
                </>
              )}
            </>
          ) : null}
        </div>
      )}

      {tooltipTitle && tooltipExtra && (
        <QuestionIcon className={styles.questionIcon} />
      )}
    </div>
  </Bubble>
);
